export default "__VITE_ASSET__DFC1kERf__"